module.exports = "<svg id=\"b26ea93b-0cca-4323-944b-fb42a951ca4f\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 51 51\"><circle class=\"circle\" cx=\"25.5\" cy=\"25.5\" r=\"25\" fill=\"none\"></circle><path class=\"line\" fill=\"#D3D3D3\" d=\"M19.57,37.62a2.5,2.5,0,0,1-2.5-2.5V17.28a2.5,2.5,0,1,1,5,0V35.12A2.5,2.5,0,0,1,19.57,37.62Z\" transform=\"translate(-0.5 -0.5)\"></path><path class=\"line\" fill=\"#D3D3D3\" d=\"M32.43,37.62a2.5,2.5,0,0,1-2.5-2.5V17.28a2.5,2.5,0,0,1,5,0V35.12A2.5,2.5,0,0,1,32.43,37.62Z\" transform=\"translate(-0.5 -0.5)\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/pause.svg
// module id = 5Y8l
// module chunks = 11